module.exports = __webpack_public_path__ + "img/rakodasi_felulet.73647ed3.svg";